import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { useStore } from "../../../root-store-context";
import Spiner from "../../../components/Spinner/Spiner";

const FileDownload: React.FC = () => {
  const { reportStore } = useStore();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!id || hasRunRef.current) return;

    hasRunRef.current = true;
    setLoading(true);
    const downloadFile = async () => {
      try {
        const response = await reportStore.PaidInvoiceDownload(id);
        if (!response || !response.data) {
          throw new Error("File download failed.");
        }
        const blob = response.data;
        const contentDisposition = response.headers["content-disposition"];
        let filename = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=["']?([^"';\n]*)["']?/
          );
          if (match && match[1]) {
            filename = decodeURIComponent(match[1]);
          }
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setLoading(false);
        await Swal.fire({
          icon: "success",
          title: "Downloaded",
          text: "Your file is being downloaded.",
          confirmButtonColor: "#44637e",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.close();
          }
        });
      } catch (error: unknown) {
        setLoading(false);
        await Swal.fire({
          text: "We're currently generating your Paid Invoice file. This may take a few moments. Please check back shortly.",
          icon: "info",
          confirmButtonColor: "#44637e",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.close();
          }
        });
      }
    };
    downloadFile();
  }, [id]);

  return (
    <>{loading && <Spiner text="Please wait, we’re preparing your file for download..." />}</>
  );
};

export default FileDownload;
